import { useEffect } from 'react';
import { Outlet } from 'react-router';

import { AppHeader } from '../../../app/components/app-header';
import { getCree8AccountUrl } from '../../../configuration/config';
import { uiStore } from '../../../core/stores/ui-store';
import { UserSettingsPageLayout } from '../../../routes/settings/components/user-settings-page.layout';

import styles from './user-settings.page.module.scss';
export const UserSettingsPage = () => {
  useEffect(() => {
    uiStore.pageTitle = {
      label: 'Personal settings',
    };

    uiStore.showBack = true;
  }, []);

  const menu = [
    {
      key: 'profile',
      label: 'Profile',
      href: `./profile`,
    },
    {
      key: 'security',
      label: 'Password and authentication',
      href: getCree8AccountUrl(),
      external: true,
    },
    {
      key: 'notifications',
      label: 'Notifications',
      href: `./notifications`,
    },
    {
      key: 'preferences',
      label: 'Preferences',
      href: `./preferences`,
    },
    {
      key: 'workspaces',
      label: 'Workspaces',
      href: `./workspaces`,
    },
  ];

  return (
    <main className={styles['main']}>
      <div className="mobile-only">
        <AppHeader />
      </div>

      <UserSettingsPageLayout title="Personal Settings" menu={menu}>
        <Outlet />
      </UserSettingsPageLayout>
    </main>
  );
};
